import React, { useEffect, useRef, useState, useContext } from 'react';
import {
  Box,
  Typography,
  Button,
  Divider,
  Grid,
  Chip,
  Dialog,
  DialogContent,
  Link,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  Stack,
} from '@mui/material';
import { poppins400, poppins500 } from 'theme/common.style';
import AiBannerStar from 'assets/svg/AiBannerStar.svg';
import { useTheme } from '@emotion/react';
import { postApiCall } from 'api/apiService';
import { MOVETO_EXCHANGE } from 'constant/app.config';
import Swal from 'sweetalert2';
import ExchangeCompletePopup from './ExchangeSuccessPopup';
import ViewContractDialog from './ViewContract';
import Loading from 'assets/images/loading.png';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ExchangeConfirmDialog = ({
  openConfirm,
  setOpenConfirm,
  price,
  winner,
  propAddress,
  depositAmount,
  settlementDays,
  propertyId,
  buyerId,
  setShowUpdateExchange,
  setOpenUpdateExchange,
  publishcard,
  unpublishcard,
  buyerContract,
  vendorContract,
  WinnerDepositAmountInt,
  setOpenShareWinner,
  from,
  profileDetails,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [isEditing, setIsEditing] = useState(false);
  // const [settlementValue, setSettlementValue] = useState(settlementDays);
  // state to open succes popup
  const [openSuccess, setOpenSuccess] = useState(false);
  // to open contract pdf
  const [openContract, setOpenContract] = useState(false);
  const [contractFile, setContractFile] = useState('');
  // loader
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const [settlementValue, setSettlementValue] = useState('');
  const { bannerApiTrigger } = useContext(datacontext);
  const history = useHistory();
  const [signedAtTime, setSignedAtTime] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    if (settlementDays !== undefined && settlementDays !== null) {
      setSettlementValue(settlementDays);
    }
  }, [settlementDays]);

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);

  const shareButtonDisable = profileDetails?.winnerSharedToAll == 1;

  const handleCloseSuccess = () => {
    setOpenSuccess(false);

    if (typeof publishcard === 'function') {
      publishcard();
    }
    if (typeof unpublishcard === 'function') unpublishcard();
  };

  const handleConfirmShare = () => {
    if (from == 'dashboard') {
      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
        state: { openShareWinner: true },
      });
      return;
    }
    setOpenSuccess(false);
    setOpenShareWinner(true);
  };

  const handleExchange = async () => {
    setLoading(true);
    const priceString = price;
    const priceInt = parseInt(priceString.replace(/[^0-9]/g, ''), 10);
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      price: priceInt,
      settlementDays: settlementValue,
      depositedPrice: WinnerDepositAmountInt,
      isExchange: 1,
    };
    try {
      const res = await postApiCall(MOVETO_EXCHANGE, params);
      bannerApiTrigger();
      if (res.data?.status !== 1) {
        Swal.fire({
          title: res?.data?.heading || 'Error',
          text: res?.data?.message || 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'Close',
        });
        setLoading(false);
      } else {
        setLoading(false);
        setOpenSuccess(true);
      }
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
    setOpenConfirm(false);
    setLoading(false);
  };

  const handleClose = () => {
    // if (
    //   !isvendorContractSigned ||
    //   !isBuyerContractSigned ||
    //   !isDepositCompleted
    // ) {
    //   setOpenConfirm(false);
    //   return;
    // }
    setOpenConfirm(false);
    setShowUpdateExchange(true);
    setSettlementValue(settlementDays);
    setOpenUpdateExchange(true);
  };

  const Pendingwarning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#F39800"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#F39800"
        />
      </svg>
    );
  };

  const Sign = () => {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_37216_88626)">
          <path
            d="M2.375 13.4583C5.01363 10.8197 6.33333 8.70833 6.33333 7.125C6.33333 4.75 5.54167 4.75 4.75 4.75C3.95833 4.75 3.14133 5.60896 3.16667 7.125C3.19358 8.74633 4.47925 10.986 5.14583 11.875C6.33333 13.4583 7.125 13.8542 7.91667 12.6667L9.5 10.2917C9.76363 12.403 10.5553 13.4583 11.875 13.4583C12.2946 13.4583 13.9642 11.875 14.25 11.875C14.6593 11.875 15.451 12.403 16.625 13.4583"
            stroke="#62CB4C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_37216_88626">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  // to open depositdetails
  const handleDepositDetails = () => {
    if (from === 'dashboard') {
      sessionStorage.setItem(
        'navAction',
        JSON.stringify({
          type: 'deposit',
          winningBuyerId: profileDetails?.isWinnerId,
          depositFlow: profileDetails?.isWinnerRequestedAmount === null,
        })
      );

      history.push(`/dashboard/view-dashboard/${propertyId}`);
    }
  };

  const handleSignRequest = (user) => {
    if (from == 'dashboard') {
      sessionStorage.setItem(
        'navAction',
        JSON.stringify({
          type: 'contract',
          user,
          winningBuyerId: profileDetails?.isWinnerId,
        })
      );

      history.push(`/dashboard/view-dashboard/${propertyId}`);
    }
  };
  const isDepositCompleted =
    from === 'dashboard'
      ? profileDetails?.isWinnerDepositStatus === 'Completed'
      : profileDetails?.PropertyDetails?.isWinnerDepositStatus === 'Completed';

  const isWinnerRequestedAmount =
    from == 'dashboard'
      ? profileDetails?.isWinnerRequestedAmount
      : profileDetails?.PropertyDetails?.isWinnerRequestedAmount;
  // for different deposit status
  const depositStatus = isDepositCompleted
    ? 'paid'
    : !isWinnerRequestedAmount
    ? 'request'
    : 'view';

  const isBuyerContractSigned =
    from === 'dashboard'
      ? profileDetails?.isWinnerContractSignStatus === 'Completed'
      : profileDetails?.PropertyDetails?.isWinnerContractSignStatus ===
        'Completed';
  const isvendorContractSigned =
    from === 'dashboard'
      ? profileDetails?.vendorEsignStatus === 'Completed'
      : profileDetails?.PropertyDetails?.vendorEsignStatus === 'Completed';
  // based on different status
  const buyerContractStatus =
    from === 'dashboard'
      ? profileDetails?.isWinnerContractSignStatus
      : profileDetails?.PropertyDetails?.isWinnerContractSignStatus;

  const vendorContractStatus =
    from == 'dashboard'
      ? profileDetails?.vendorEsignStatus
      : profileDetails?.PropertyDetails?.vendorEsignStatus;

  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const OpenBinderChat = (currentBinder) => {
    if (currentBinder) {
      setOpenConfirm(false);
      setTimeout(() => {
        setMessagedata({ binderId: currentBinder });
        setShowMessage(true);
      }, 200);
    }
  };
  return (
    <>
      <Dialog
        open={openConfirm}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: matches450 ? '100%' : '720px',
            maxWidth: matches450 ? '100%' : 'unset',
            padding: matches450 ? 1 : 2,
            // m: matches450 ? 1 : 'auto', // margin to avoid edge touch on small screens
          },
        }}
      >
        <DialogTitle sx={{ p: 2, pl: 3, pr: 3, fontWeight: 600 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: '14px',
                color: '#666666',
              }}
            >
              {propAddress}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 0, px: 3, pb: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, color: '#000000', fontSize: '24px' }}
            >
              Exchange Status Confirmation
            </Typography>
          </Box>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={3}
            mb={2}
          >
            Please confirm the property transaction can now be marked as
            EXCHANGED. The listing will be moved to the exchanged section until
            it settles.
          </Typography>
          <Divider sx={{ my: 2, mx: -3 }} />
          <Typography
            sx={{
              ...poppins400,
              fontSize: '24px',
              color: '#000000',
            }}
          >
            Summary
          </Typography>

          <Grid container direction="column" spacing={2} pl={1}>
            <Grid item container mt={3} alignItems="flex-start">
              {/* Label */}
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Property:
                </Typography>
              </Grid>

              {/* Value */}
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {propAddress}
                </Typography>
              </Grid>
            </Grid>
            {/* Price */}
            <Grid item container mt={3}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Price:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {price}
                </Typography>
              </Grid>
            </Grid>

            {/* Settlement Days */}
            <Grid
              item
              container
              mt={3}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Settlement days:
                </Typography>
              </Grid>

              {/* <ClickAwayListener onClickAway={handleClickAway}> */}
              <Grid item xs zeroMinWidth ml={7}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    display: 'inline',
                  }}
                >
                  {/* <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    > */}
                  {/* <Box display="flex" alignItems="center"> */}
                  {/* <TextField
                          inputRef={inputRef}
                          value={settlementValue}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          sx={{ width: 70, mr: 1 }}
                          inputProps={{
                            min: 0,
                            max: 999,
                            readOnly: !isEditing,
                            sx: {
                              ...poppins400,
                              fontSize: '16px',
                              color: '#000000',
                            },
                          }}
                        /> */}
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '16px',
                      color: '#000000',
                    }}
                  >
                    {settlementDays} days after the exchanged contract date
                  </Typography>
                  {/* </Box> */}
                  {/* <IconButton onClick={handleEditClick}>
                        <Editbox />
                      </IconButton> */}
                  {/* </Box> */}
                </Typography>
              </Grid>
              {/* </ClickAwayListener> */}
            </Grid>

            {/* Buyer */}
            <Grid item container mt={3}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Buyer:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {winner}
                </Typography>
              </Grid>
            </Grid>

            {/* Buyer Contract */}
            <Grid item container mt={3} alignItems="center">
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Buyer Contract:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                {buyerContractStatus === 'Completed' ? (
                  // ✅ COMPLETED
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '16px',
                        color: '#000000',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Stack
                        direction={'row'}
                        alignItems="center"
                        spacing={1}
                        sx={{
                          borderRadius: '15px',
                          backgroundColor: '#CEFECE',
                          padding: '4px 8px',
                          minHeight: '32px',
                          width: 'fit-content',
                        }}
                      >
                        <Sign sx={{ color: '#3FBA20' }} />

                        <Typography
                          sx={{
                            fontSize: matches450 ? '14px' : '16px',
                            fontFamily: 'Poppins',
                            fontWeight: 500,
                            color: '#3FBA20',
                          }}
                        >
                          Signed
                        </Typography>
                      </Stack>
                      <Link
                        // href="#"
                        underline="none"
                        sx={{
                          color: '#007AFF',
                          ...poppins400,
                          fontSize: '16px',
                          ml: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setPdfLoading(true);
                          setContractFile(buyerContract);
                          setSignedAtTime(
                            profileDetails?.PropertyDetails
                              ?.isWinnerContractSignedAt ||
                              profileDetails?.isWinnerContractSignedAt
                          );
                          setOpenContract(true);
                        }}
                      >
                        View
                      </Link>
                    </Typography>
                  </Box>
                ) : buyerContractStatus === 'Action Required' ||
                  buyerContractStatus === 'Requested' ? (
                  // 🟠 ACTION REQUIRED
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      // href="#"
                      underline="always"
                      sx={{
                        color: '#007AFF',
                        ...poppins400,
                        fontSize: '16px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleSignRequest('buyer');
                      }}
                    >
                      Prepare Contract
                    </Link>
                  </Box>
                ) : buyerContractStatus === 'Pending Buyer Signature' ? (
                  // 🔵 PENDING BUYER SIGNATURE
                  <Link
                    // href="#"
                    underline="always"
                    sx={{
                      color: '#007AFF',
                      ...poppins400,
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      OpenBinderChat(profileDetails?.isWinnerContractBinderId);
                    }}
                  >
                    Pending Buyer Signature
                  </Link>
                ) : (
                  // 🟡 DEFAULT
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      color: '#F39800',
                    }}
                  >
                    Pending
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Vendor Contract */}
            <Grid item container mt={2} alignItems="center">
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Vendor Contract:
                </Typography>
              </Grid>

              <Grid item xs zeroMinWidth ml={6}>
                {vendorContractStatus === 'Completed' ? (
                  <Box display="flex" alignItems="center">
                    <Stack
                      direction={'row'}
                      alignItems="center"
                      spacing={1}
                      sx={{
                        borderRadius: '15px',
                        backgroundColor: '#CEFECE',
                        padding: '4px 8px',
                        minHeight: '32px',
                        width: 'fit-content',
                      }}
                    >
                      <Sign sx={{ color: '#3FBA20' }} />

                      <Typography
                        sx={{
                          fontSize: matches450 ? '14px' : '16px',
                          fontFamily: 'Poppins',
                          fontWeight: 500,
                          color: '#3FBA20',
                        }}
                      >
                        Signed
                      </Typography>
                    </Stack>{' '}
                    <Link
                      // href="#"
                      underline="none"
                      sx={{
                        color: '#007AFF',
                        ...poppins400,
                        fontSize: '16px',
                        ml: 0.5,
                        cursor: 'pointer',
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setPdfLoading(true);
                        setContractFile(vendorContract);
                        setSignedAtTime(
                          profileDetails?.PropertyDetails
                            ?.vendorContractSignedAt ||
                            profileDetails?.vendorContractSignedAt
                        );
                        setOpenContract(true);
                      }}
                    >
                      View
                    </Link>
                  </Box>
                ) : vendorContractStatus == null ? (
                  // 🟠 ACTION REQUIRED
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      // href="#"
                      underline="always"
                      sx={{
                        color: '#007AFF',
                        ...poppins400,
                        fontSize: '16px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleSignRequest('vendor');
                      }}
                    >
                      Prepare Contract
                    </Link>
                  </Box>
                ) : vendorContractStatus === 'Requested' ? (
                  <Link
                    // href="#"
                    underline="always"
                    sx={{
                      color: '#007AFF',
                      ...poppins400,
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      OpenBinderChat(profileDetails?.vendorEsignStatusBinderId);
                    }}
                  >
                    Pending Vendor Signature
                  </Link>
                ) : (
                  // 🟡 DEFAULT FALLBACK
                  <Box
                    sx={{
                      borderRadius: '15px',
                      backgroundColor: '#F398001A',
                      padding: '4px 8px',
                      width: 'fit-content',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: matchessm ? '14px' : '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: '#F39800',
                      }}
                    >
                      Pending
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>

            {/* Deposit Amount */}
            <Grid item container alignItems="center" mt={2}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Deposit Amount:
                </Typography>
              </Grid>

              <Grid item xs zeroMinWidth ml={6}>
                {depositStatus === 'paid' ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '16px',
                        color: '#000',
                        wordBreak: 'break-word',
                      }}
                    >
                      {depositAmount}
                    </Typography>
                    <Chip
                      label="Paid"
                      size="small"
                      sx={{
                        ...poppins400,
                        fontSize: '13px',
                        color: 'white',
                        backgroundColor: '#08A742',
                        height: 24,
                        width: 71,
                        ml: 1,
                      }}
                    />
                  </Box>
                ) : (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      // href="#"
                      underline="always"
                      sx={{
                        color: '#007AFF',
                        ...poppins400,
                        fontSize: '16px',
                        cursor: 'pointer',
                      }}
                      onClick={handleDepositDetails}
                    >
                      {depositStatus === 'request'
                        ? 'Request Deposit'
                        : 'View Deposit Details'}
                    </Link>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>

          {/* Bottom Note */}
          <Box
            marginTop={8}
            marginBottom={4}
            sx={{
              maxWidth: '620px',
              pt: 1.5,
              pb: 1.5,
              borderRadius: 2,
              border: '1px solid #965CF0',
            }}
            display={'flex'}
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
          >
            <img
              src={AiBannerStar}
              alt="Star"
              style={{
                height: '35px',
                width: '35px',
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              By confirming listing status retreX can better assist with
              automating and managing next steps for you.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 7 }}>
          <Button
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              width: 100,
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#4CA4D6',
              borderRadius: '8px',
              textTransform: 'none',
              whiteSpace: 'nowrap',
              minWidth: 'fit-content',
              // px: 2,
              '&:hover': {
                bgcolor: '#3293d0',
              },
            }}
            onClick={handleExchange}
            disabled={
              !isvendorContractSigned ||
              !isBuyerContractSigned ||
              !isDepositCompleted
            }
          >
            Confirm Exchange
          </Button>
          {loading && (
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '40px', width: '40px' }}
            />
          )}
        </DialogActions>
      </Dialog>

      <ExchangeCompletePopup
        open={openSuccess}
        onClose={handleCloseSuccess}
        address={propAddress}
        handleConfirmShare={handleConfirmShare}
        shareButtonDisable={shareButtonDisable}
        profileDetails={profileDetails}
      />
      <ViewContractDialog
        open={openContract}
        onClose={() => setOpenContract(false)}
        contractFile={contractFile}
        signedAt={signedAtTime}
        address={propAddress}
        pdfLoading={pdfLoading}
        setPdfLoading={setPdfLoading}
      />
      {/* confoirmation for sharing winning offer */}
    </>
  );
};

export default ExchangeConfirmDialog;
